/* stylelint-disable */
:host {
  display: inline;
}

@media screen and (min-width: 980px) {
  .cta-button {
    width: 100%;
  }
}

.cta-button.qds-customized-multiline-large-button {
  --qds-control-hero-border-radius: var(--qds-control-border-radius);
  --qds-control-hero-text: var(--qds-control-large-text);
  --qds-control-hero-gap-internal: var(--qds-control-large-gap-internal);
  --qds-control-hero-padding-auto-height: var(--qds-control-large-padding-auto-height);
  --qds-control-button-hero-padding-horizontal: var(--qds-control-button-large-padding-horizontal);
}

.cta-button.qds-customized-multiline-standard-button {
  --qds-control-hero-border-radius: var(--qds-control-border-radius);
  --qds-control-hero-text: var(--qds-control-standard-text);
  --qds-control-hero-gap-internal: var(--qds-control-standard-gap-internal);
  --qds-control-hero-padding-auto-height: var(--qds-control-standard-padding-auto-height);
  --qds-control-button-hero-padding-horizontal: var(--qds-control-button-standard-padding-horizontal);
}

@media screen and (min-width: 980px) {
  .cta-button--max-200 {
    width: 200px;
  }
}

@media screen and (min-width: 980px) {
  .cta-button--max-250 {
    width: 250px;
  }
}